import {mapGetters} from "vuex";
import {directive as onClickaway} from 'vue-clickaway';
import CountryFlag from 'vue-country-flag';
import { updateLocale } from "moment/moment";

export default {
    name: 'language-switcher',
    components: {
        CountryFlag,
    },
    directives: {
        onClickaway: onClickaway,
    },
    data() {
        return {
            open: false
        }
    },
    computed: {
        ...mapGetters([
            'currentLanguage',
            'languages'
        ]),
        languagesList() {
            return this.languages.map(item=>{
                if(item.translationKey == 'uk') { item.flagKey='ua';}
                if(item.translationKey == 'en') { item.flagKey='us';}
                return item;
            })
        }
    },
    methods: {
        changeLanguage(item) {
            this.open = false;
            this.$setLanguage(item.code)
        },
        close() {
            this.open = false
        }
    }
}
